module.exports = __webpack_public_path__ + "img/audio_speaker.fdcf6d70.svg";